module.exports = __webpack_public_path__ + "travelStaytion-src-icon.png?541204b41cc25bba0236d8eb14b79611";